module.exports = __webpack_public_path__ + "media/images/icons/social-twitter-c7736bcc75ca9a53e8fb8e9491e7a535.svg";